var commonStyles = {"component":"typography__component_12zwb","bold":"typography__bold_12zwb","semibold":"typography__semibold_12zwb","medium":"typography__medium_12zwb","regular":"typography__regular_12zwb"};
require('./title/common.css');

export { commonStyles as c };
